import { Chip } from '@mui/material';

const getActionColor = (action = '') => {
    const act = action.toUpperCase();
    if (act.includes('APPROVED') || act.includes('CREATED')) return 'success';
    if (act.includes('REJECTED') || act.includes('DELETED')) return 'error';
    if (act.includes('CANCELLED') || act.includes('UPDATED')) return 'warning';
    if (act.includes('APPLIED')) return 'info';
    return 'default';
};

const ActionChip = ({ action = '', size = 'small', sx = {} }) => {
    const color = getActionColor(action);
    return (
        <Chip
            size={size}
            label={action}
            color={color}
            variant='outlined'
            sx={{
                fontWeight: 600,
                fontSize: '0.75rem',
                textTransform: 'uppercase',
                letterSpacing: '0.02em',
                ...sx
            }}
        />
    );
};

export default ActionChip;
